import { render, staticRenderFns } from "./SmsListItem.vue?vue&type=template&id=b06e3ed0&scoped=true&"
import script from "./SmsListItem.vue?vue&type=script&lang=js&"
export * from "./SmsListItem.vue?vue&type=script&lang=js&"
import style0 from "./SmsListItem.vue?vue&type=style&index=0&id=b06e3ed0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b06e3ed0",
  null
  
)

export default component.exports